import React from 'react';
import { Brain, Heart, Home, Clock, Sparkles } from 'lucide-react';
import { Section } from './Shared';
export function ProductSection() {
  const benefits = [{
    icon: <Brain className="w-8 h-8 text-sage-dark" data-id="element-170" />,
    title: 'Desarrollo integral'
  }, {
    icon: <Heart className="w-8 h-8 text-sage-dark" data-id="element-171" />,
    title: 'Más conexión con tu bebé'
  }, {
    icon: <Home className="w-8 h-8 text-sage-dark" data-id="element-172" />,
    title: 'Actividades en casa'
  }, {
    icon: <div className="w-8 h-8 text-sage-dark" data-id="element-173" />,
    title: 'Menos pantallas'
  }, {
    icon: <Clock className="w-8 h-8 text-sage-dark" data-id="element-174" />,
    title: 'Rutinas suaves y reales'
  }, {
    icon: <Sparkles className="w-8 h-8 text-sage-dark" data-id="element-175" />,
    title: 'Estimulación sin presión'
  }];
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-176">
      <Section data-id="element-177">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-178">
          {benefits.map((benefit, i) => <div key={i} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center group hover:shadow-md transition-all duration-300" data-id="element-179">
              <div className="bg-sage-light/30 p-4 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-180">
                {benefit.icon}
              </div>
              <p className="text-charcoal font-medium text-lg" data-id="element-181">
                {benefit.title}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-182">
          <p className="inline-block bg-white border border-beige-muted/50 text-charcoal text-lg font-medium px-8 py-4 rounded-full shadow-sm italic" data-id="element-183">
            Creado para mamás reales, no para rutinas perfectas.
          </p>
        </div>
      </Section>
    </div>;
}